import { EventEntity } from '../types/EventEntity';

// ============================================================================
// GAME EVENTS
// ============================================================================

// ============================================================================
// EVENT HELPER FUNCTIONS
// ============================================================================

/**
 * Initialize event timers if they don't exist
 */
function initializeEventTimers(gameState: any): void {
  if (!gameState.eventTimers) {
    gameState.eventTimers = {};
  }
}

/**
 * Check if an event has already been triggered by checking achievements
 */
function hasEventTriggered(gameState: any, eventId: string): boolean {
  return (gameState.achievements || []).includes(eventId);
}

/**
 * Start a timer for an event if not already started
 */
function startEventTimer(gameState: any, eventId: string): void {
  initializeEventTimers(gameState);
  if (!gameState.eventTimers[eventId]) {
    gameState.eventTimers[eventId] = Date.now();
  }
}

/**
 * Get elapsed time since event timer started (in milliseconds)
 */
function getEventTimerElapsed(gameState: any, eventId: string): number {
  initializeEventTimers(gameState);
  const startTime = gameState.eventTimers[eventId];
  return startTime ? Date.now() - startTime : 0;
}

/**
 * Reset/clear an event timer
 */
function resetEventTimer(gameState: any, eventId: string): void {
  initializeEventTimers(gameState);
  delete gameState.eventTimers[eventId];
}

export function defineEvents(): EventEntity[] {
  return [
    new EventEntity(
      'zuckerbergPoaching',
      'Meta Talent Acquisition',
      'Mark Zuckerberg personally reached out to half of your AI Research team with an offer they couldn\'t refuse.',
      1.0, // 100% probability when condition is met
      5000, // Display for 5 seconds
      (gameState) => {
        // Check if already triggered
        if (hasEventTriggered(gameState, 'zuckerbergPoaching')) {
          return false;
        }

        // Check if conditions are met
        const hasEnoughResearchers = (gameState.personnel.aiResearcher || 0) >= 2;
        const hasAdvancedAI = gameState.upgrades.advancedAI === true;

        // Reset timer if conditions no longer met
        if (!hasEnoughResearchers || !hasAdvancedAI) {
          resetEventTimer(gameState, 'zuckerbergPoaching');
          return false;
        }

        // Start timer when conditions are first met
        startEventTimer(gameState, 'zuckerbergPoaching');

        // Trigger after 60 seconds (60000ms) of having 2+ researchers
        return getEventTimerElapsed(gameState, 'zuckerbergPoaching') >= 60000;
      },
      (game) => {
        const currentResearchers = game.state.personnel.aiResearcher || 0;
        const researchersLost = Math.floor(currentResearchers / 2);

        // Remove half the AI researchers
        game.state.personnel.aiResearcher = currentResearchers - researchersLost;

        // Grant achievement to mark event as triggered
        if (!game.state.achievements.includes('zuckerbergPoaching')) {
          game.state.achievements.push('zuckerbergPoaching');
        }

        game.log(
          `💼 ${researchersLost} AI Researcher${researchersLost > 1 ? 's have' : ' has'} left for Meta! You now have ${game.state.personnel.aiResearcher} researcher${game.state.personnel.aiResearcher !== 1 ? 's' : ''} remaining.`,
          'warning'
        );
      }
    ),
  ];
} 